import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

function EventCard({ items, thematic_area = false }) {
  const lang = useSelector((state) => state?.local?.local);
  return (
    <div>
      <div>
        {items?.length === 0 ? (
          <h6 className="text-center text-danger">
            <FormattedMessage id="not_enrolled_in_any_event_msg" />
          </h6>
        ) : (
          <div className="row" style={{ maxHeight: '200px', overflow: 'auto' }}>
            <div className="col-12  ">
              {!thematic_area && (
                <div className="row ">
                  <div className="col-lg-8 col-md-3 col-sm-3 pt-3  ">
                    <p className="gray-100">
                      <FormattedMessage id="event.name" />
                    </p>
                  </div>
                  <div className="col-lg-4 col-md-3 col-sm-3 pt-3">
                    <p className=" gray-100">
                      <FormattedMessage id="event.date" />
                    </p>
                  </div>
                </div>
              )}
              {items?.map((item) => {
                const title =
                  lang === 'ne' ? item?.title_nepali : item?.title_english || item?.title_nepali;

                return (
                  <>
                    <div className="row switch-row ">
                      <div className="col-lg-8 col-md-3 col-sm-3 pt-3 ">
                        <p className=" gray-100">{title}</p>
                      </div>
                      {!thematic_area && (
                        <div className="col-lg-4 col-md-3 col-sm-3 pt-3">
                          <p className=" gray-100">
                            {lang === 'ne' ? item?.start_date_bs : item?.start_date}
                          </p>
                        </div>
                      )}
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        )}

        {/* <nav aria-label="Page navigation example">
        <ul className="pagination mt-5 d-flex justify-content-center">
          <li className="page-item">
            <a className="page-link mr-5" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
              <span className="sr-only">Previous</span>
            </a>
          </li>
          <li className="page-item pr-5"><a className="page-link active-state" href="#">1</a></li>
          <li className="page-item pr-5"><a className="page-link gray-100" href="#">2</a></li>
          <li className="page-item pr-5"><a className="page-link gray-100" href="#">3</a></li>
          <li className="page-item pr-5"><a className="page-link gray-100" href="#">4</a></li>
          <li className="page-item pr-5"><a className="page-link gray-100" href="#">5</a></li>
          
          <li className="page-item">
            <a className="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
              <span className="sr-only">Next</span>
            </a>
          </li>
        </ul>
      </nav> */}
      </div>
    </div>
  );
}

export default EventCard;
